/* eslint-disable camelcase */
import _ from 'lodash';

const setEndorsementDescription = (currentStepLabel, endorsementVM, translator) => {
    const label = _.isObject(currentStepLabel) ? translator(currentStepLabel) : currentStepLabel
    const description = endorsementVM.description_ML.value;
    if (!description) {
        endorsementVM.description_ML.value = label;
    } else if (description !== label) {
        /* If Endorsement has ', Excluded Drivers' in its Description, 'Drivers' cannot be added using description.includes(currentStepLabel)
           So, it makes a Set for existing description using comma separator and checks if it has any duplicate description
         */
        const labelsSet = new Set(endorsementVM.description_ML.value.split(', '));
        if (!labelsSet.has(label)) {
            endorsementVM.description_ML.value = `${description}, ${label}`;
        }
    }
};

const stepLabel = (currentStep) => {
    return !currentStep.label ? currentStep.title : currentStep.label;
};

const doesDriverHaveAccidentPrevention = (endorsement) => {
    const drivers = endorsement.lobData.personalAuto.coverables.drivers;
    let hasAccPrev = false;
    drivers.forEach((driver) => {
        let accPrevMod;
        if (driver.driverModifiers_ML && driver.driverModifiers_ML.modifiers) {
            if (endorsement.isDriverPrimaryVehicleRequiredState_Ext) {
                accPrevMod = endorsement.policyAddress.state === 'NJ' ? _.findWhere(driver.driverModifiers_ML.modifiers, {codeIdentifier_ML: 'PADefensiveDriver_ML'}) :
                    _.find(driver.driverModifiers_ML.modifiers, {codeIdentifier_ML: 'PADriverAccidentPrevention_ML'});
            } else {
                accPrevMod = _.find(driver.driverModifiers_ML.modifiers, {codeIdentifier_ML: 'PADriversRoleModiferPreventionCourse_ML'});
            }
        }
        if (accPrevMod && accPrevMod.chosenTermValue === 'true') {
            hasAccPrev = true;
        }
    });
    return hasAccPrev;
};

const isAccidentPreventionStateAndSelected = (steps, endorsement) => {
    if (endorsement) {
        if (!endorsement.isPersonalAuto()) {
            return false;
        }
        const isAccPrevState = endorsement.isVehiclePrimaryDriverPercentageState_Ext || endorsement.isVehiclePrimaryDriverState_Ext || endorsement.isDriverPrimaryVehicleRequiredState_Ext;
        const isAccPrevChosen = doesDriverHaveAccidentPrevention(endorsement);
        const visitedDriversOrVehicles = steps.some((step) => step.name === 'endorsementPaDrivers' || step.name === 'endorsementPaVehicles'
            || step.name === 'endorsementPaListVehicles' || step.name === 'endorsementPaListDrivers');
        return isAccPrevState && isAccPrevChosen && visitedDriversOrVehicles;
    }
    return false;
};

export default {
    setEndorsementDescription: setEndorsementDescription,
    stepLabel: stepLabel,
    isAccidentPreventionStateAndSelected: isAccidentPreventionStateAndSelected
};
